"use client";

import { useDraftModeContext } from "components/draft-mode-provider";

export function useDraftMode(): boolean {
  return useDraftModeContext();
}
